import { render, staticRenderFns } from "./ed-list-user-requests.component.vue?vue&type=template&id=7cc1855d&scoped=true&"
import script from "./ed-list-user-requests.component.ts?vue&type=script&lang=ts&"
export * from "./ed-list-user-requests.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-list-user-requests.component.scss?vue&type=style&index=0&id=7cc1855d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc1855d",
  null
  
)

export default component.exports